import { LOGIN_URL } from "@/utils/constants/constants";
import { CookieKeys, Cookies } from "@/utils/cookieKey";
import { Loading, Message } from "element-ui";
import store from "@/store";
// import router from "@/router";
import { AUTH_KEY_MAP, FEATURES_CODE } from "@/utils/constants/constants.auth";
import { v4 as uuidv4 } from "uuid";
import { USER_CENTER_URL } from "@/utils/constants/constants.menu";
import _ from "lodash";
import { restUCompanyGetCompanyInfo } from "@/services/common/basic";
import md5 from "md5";

/** 公共方法 **/

/** 深拷贝 **/
export function deepClone(source) {
  if (!source) return;
  const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for (let keys in source) {
    // 遍历目标
    if (Object.hasOwnProperty.call(source, keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}
/** 深度比较 **/
export function deepCompare(a, b) {
  if (a === null || typeof a !== "object") return a === b;
  const propsA = Object.getOwnPropertyDescriptors(a);
  const propsB = Object.getOwnPropertyDescriptors(b);
  if (Object.keys(propsA).length !== Object.keys(propsB).length) return false;
  return Object.keys(propsA).every((key) => deepCompare(a[key], b[key]));
}

// 退登形式 自动 or 手动
export const LOGOUT_TYPE = {
  AUTO: "auto",
  MANUAL: "manual",
};

// 跳转至登录页
export function redirectToLoginPage(logoutType) {
  // 清除cookies
  clearCookies();
  // 设置cookies
  setCookies(logoutType);
  // 页面跳转
  // router.replace({ path: LOGIN_URL });
  window.location.replace(LOGIN_URL);
}

function setCookies(logoutType) {
  let backUrl;
  switch (logoutType) {
    case LOGOUT_TYPE.AUTO:
      backUrl = window.location.href;
      break;
    case LOGOUT_TYPE.MANUAL:
      backUrl = USER_CENTER_URL;
      break;
  }
  Cookies.set("backUrl", backUrl, {
    domain: ".qianlima.com",
  });
}

// 清除cookies
export function clearCookies() {
  try {
    Cookies.remove(`${Cookies.get("qlm_username")}${Cookies.get("qlm_password")}`, "", {
      path: "/",
      domain: ".qianlima.com",
    });
  } catch (e) {
    console.error("clear Cookies error: ", e);
  }
  Cookies.remove("qlm_username", { path: "/", domain: ".qianlima.com" });
  Cookies.remove("qlm_password", { path: "/", domain: ".qianlima.com" });
  Cookies.remove("xAuthToken", { path: "/", domain: ".qianlima.com" });
  Cookies.remove("userInfo", { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userAppMenu, {
    path: "/",
    domain: ".qianlima.com",
  });
  Cookies.remove(CookieKeys.userLeftMenuClick, {
    path: "/",
    domain: ".qianlima.com",
  });
}

/**局部loading */
export function loadMore(options = {}) {
  return Loading.service({
    lock: true,
    text: options.text || "加载中...",
    background: "#fff",
    target: options.target || "",
    fullscreen: false,
  });
}

/** 服务热线 **/
export function getServicePhone() {
  try {
    if (authCheck(AUTH_KEY_MAP.VIP_CUSTOM_SERVICE_PHONE_NUM)) {
      return "400-900-6616";
    } else {
      return "400-688-2000";
    }
  } catch (e) {
    return "400-900-6616";
  }
}

/** 获取指定日期的结束时间戳 **/
export function endTimestamp(timestamp) {
  const todayDate = timestamp ? new Date(timestamp) : new Date();
  return new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + 1).getTime();
}

// 判断是否是空的
export function IsNull(str) {
  return (
    str === undefined ||
    str === "undefined" ||
    str === null ||
    str === "null" ||
    str.length === 0 ||
    JSON.stringify(str) === "{}"
  );
}

/**
 * 判断该功能是否有权限
 * @returns  {Array} 功能列表
 */
export function getLocalAuths() {
  const localAuths = [];
  FEATURES_CODE.forEach(async (feature) => {
    localAuths.push({
      code: feature.code,
      is_valid: await feature.rules(store),
      err_msg: feature.err_msg,
    });
  });
  return localAuths;
}

/**
 * 判断该功能是否灰度,或用户权限
 * @param authKey 表示该功能的code标识 如：time-custom，详见constants.auth.js 或 灰度接口
 * @param needShowMessageWarn
 * @returns {Boolean}
 */
// 形式1：弹消息
// 形式2：只将该模块显示与隐藏
export function authCheck(authKey, needShowMessageWarn = false) {
  try {
    const grayReleaseAndLocalAuthCombinedArr = [
      ...store.getters["basic/localAuth"], // 本地权限数据
      ...store.getters["basic/grayReleaseFeatures"].features.map((value) => ({
        code: value.code,
        is_valid: value.grayRelease,
      })), // 灰度接口权限数据
    ];
    return grayReleaseAndLocalAuthCombinedArr.some((item) => {
      if (item.code === authKey) {
        if (needShowMessageWarn && !item.is_valid && item.err_msg) {
          Message({
            type: "warning",
            message: item.err_msg(),
          });
        }
        return item.is_valid;
      }
    });
  } catch (e) {
    console.error(e);
    // 无权限
    return false;
  }
}

function curryingReplace(reg, replacement) {
  return function (str = "") {
    return str.replace(reg, replacement);
  };
}

// 替换字符为加密字符
export function replaceEncryptStr(str, options = {}) {
  const { startNum = 4, endNum = 4, replacement = "$1****$2" } = options;
  const reg = new RegExp(`(.{${startNum}}).*(.{${endNum}})`);
  return curryingReplace(reg, replacement)(str);
}

/** 字符串根据传入长度拼接省略号 **/
export function stringEllipsisor(value, length) {
  if (!value) return "";
  value = value.toString();
  if (value.length > length) {
    return value.substr(0, length) + "... ";
  }
  return value;
}

/** 生成唯一ID **/
export function getUUID() {
  return uuidv4();
}

/**
 * 时间转换
 * @param {number} time 需要转换的时间
 * @param {String} cFormat 格式 {y}-{m}-{d} {h}:{i}:{s}
 * @return: {String} timeStr 转换完成的时间
 */
export function DateFormat(time, cFormat) {
  if (arguments.length === 0) {
    return "-";
  }
  if (time === null) {
    return "-";
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (time === "") {
    date = new Date();
  } else if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    if (String(time).indexOf("T") > -1) {
      time = time.replace(/T/g, " ").replace(/\..*/g, "");
    }
    if (String(time).indexOf("-") > -1 && String(time).indexOf("T") === -1) {
      time = time.replace(/-/g, "/");
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return timeStr;
}

// 倒计时
export function timeCountdown(time, callback) {
  const timer = setInterval(() => {
    time--;
    callback(time);
    if (time === 0) {
      clearInterval(timer);
    }
  }, 1000);
}

//时间戳转换年月日格式
export function getData(n) {
  let now = new Date(n),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
}

/**
 * 时间显示效果显示
 * @param {String} time 需要转换的时间
 * @param {String} option 格式 {y}-{m}-{d} {h}:{i}:{s}
 * @return: {String} 转换完成的时间
 */
export function conversionTime(time) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();
  if (d.toDateString() === new Date().toDateString()) {
    const diff = (now - d) / 1000;
    if (diff < 60) {
      return "1分钟前";
    } else if (diff < 3600) {
      // less 1 hour
      return Math.floor(diff / 60) + "分钟前";
    } else {
      return Math.floor(diff / 3600) + "小时前";
    }
  } else if (d < new Date()) {
    return getData(time);
  }
}

/** 从URL中获取query，禁止在本项目$route.query能获取时使用 **/
export function getQuery(fullPath) {
  const url = fullPath || window.location.href;
  const queryObj = {};
  if (!url.includes("?")) {
    return {};
  }
  url
    .split("?")[1]
    .split("&")
    .map((i) => (queryObj[i.split("=")[0]] = i.split("=")[1]));
  return queryObj;
}

/** 返回且或关系文案 **/
export function andOrLabel(keywordsAndOr) {
  if (keywordsAndOr === "|") {
    return "包含任意关键词";
  }
  if (keywordsAndOr === "&") {
    return "包含全部关键词";
  }
  return "包含任意关键词";
}

/**
 * 高亮
 * @param {String} str
 * @param {Array} keywords
 * @returns
 */
export const highlight = (str, keywords) => {
  let formatStr = str;
  let keywordsJoin = keywords.join("|");

  // 格式化特殊字符
  const specialCharacter = ["\\", "$", "(", ")", "*", "+", ".", "[", "?", "^", "{"];
  specialCharacter.forEach((v) => {
    let reg = new RegExp("\\" + v, "gim");
    keywordsJoin = keywordsJoin.replace(reg, "\\" + v);
  });

  return formatStr.replace(new RegExp(`(${keywordsJoin})`, "g"), '<span style="color: #df6250">$1</span>');
};

/**
 * 推荐指数（星星）
 * @param {Number, String} num
 * @returns
 */
export const formatStarNumArr = (num) => {
  const startNum = Number(num);
  let resStar = []; //储存各种星星样式的数量
  let hasDecimal = startNum % 1 !== 0; //是否有小数
  let integer = Math.floor(startNum); //判断整数
  for (let i = 0; i < integer; i++) {
    resStar.push("fa-star"); //实星 的数量
  }
  if (hasDecimal) {
    resStar.push("fa-star-half-empty"); //有小数填充一个 半实星
  }
  while (resStar.length < 5) {
    resStar.push("fa-star-o"); //用 空星 填充后面的
  }
  return resStar;
};
// 监听元素高度变化
export const elementResize = {
  bind(el, binding) {
    let width = "",
      height = "";

    function isResize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value();
      }
      width = style.width;
      height = style.height;
    }

    el._vueSetInterval_ = setInterval(isResize, 100);
  },
  unbind(el) {
    clearInterval(el._vueSetInterval_);
  },
};

//金额转换元或万元
export function formatNumberToMoney(num) {
  num = Number(num);
  if (num === 0) {
    return num + "元";
  } else if (num > 1 && num < 10000) {
    return num + "元";
  } else if (Object.is(num, NaN)) {
    return "-";
  } else {
    num = parseInt(num / 100);
    return num / 100 + "万元";
  }
}

/** 页面离开浏览器提示 */
function beforeUnloadHandler(e) {
  e.returnValue = "离开此页面？";
}

export const browserLeaveTips = {
  addEventListener: () => {
    global.addEventListener("beforeunload", beforeUnloadHandler, false);
  },
  removeEventListener: () => {
    global.removeEventListener("beforeunload", beforeUnloadHandler, false);
  },
};

/**超过某个高度，滚动条回到某个位置
 * exceedHeight  超过某个高度 默认0
 * goToHeight  回到摸个位置
 */
export function setScrollTop(exceedHeight = 0, goToHeight = 0) {
  if (document.documentElement.scrollTop > exceedHeight) {
    document.documentElement.scrollTop = goToHeight;
  }
}

/**
 * 判断数据是否为空
 * @param {*} value 数据
 * @returns boolean
 */
export function isValEmpty(value) {
  if (typeof value === "object" && value !== null) {
    // isEmpty 方法可以检查 value 是否为一个空对象、集合、映射或者 set。
    return _.isEmpty(value);
  } else {
    // isNil 方法可以检查一个值是否是 null 或者 undefined
    return _.isNil(value) || value === "";
  }
}

export function getDocumentReferer() {
  let referrer = encodeURI(document.referrer);
  let referUrl = "";
  if (referrer) {
    referUrl = getQuery(referrer) ? getQuery(referrer).referUrl : "";
  }

  return referUrl || "";
}

/**
 * 设置用户信息
 */
export async function setUserInfo() {
  // 用户信息
  const userInfo = await restUCompanyGetCompanyInfo();
  // // 优秀供应商 - 星级
  // let excellentSupplierStarLevel = 0;
  // try {
  //   const res = await restAccountSupplierStarSearch();
  //   excellentSupplierStarLevel = res.data;
  // } catch (e) {
  //   e;
  // }
  let userInfoData = userInfo.data;
  store.commit("basic/updateUserInfo", {
    ...userInfo.data,
  });
  userInfoData.companyArea = ""; //TODO:后期要修改为localStorage
  Cookies.set(CookieKeys.userInfo, JSON.stringify(userInfoData), { domain: ".qianlima.com" });

  const { userId } = userInfo.data;
  let last_qlm_uid_md5 = localStorage.getItem("qlm_uid_md5");
  console.log("last_qlm_uid_md5", last_qlm_uid_md5);
  if (!last_qlm_uid_md5) {
    if (JSON.parse(localStorage.getItem("wmUserInfo"))) {
      console.log("wmUserInfo", JSON.parse(localStorage.getItem("wmUserInfo")));
      last_qlm_uid_md5 = md5(JSON.parse(localStorage.getItem("wmUserInfo")).userId);
      console.log("last_qlm_uid_md5", last_qlm_uid_md5);
    }
  }
  const qlm_uid_md5 = md5(userId);
  console.log("qlm_uid_md5", qlm_uid_md5);
  if (last_qlm_uid_md5 !== qlm_uid_md5) localStorage.clear();
  localStorage.setItem("qlm_uid_md5", md5(userId));
}
